import { render, staticRenderFns } from "./TableStock.vue?vue&type=template&id=2b28d0c1&scoped=true"
import script from "./TableStock.vue?vue&type=script&lang=js"
export * from "./TableStock.vue?vue&type=script&lang=js"
import style0 from "./TableStock.vue?vue&type=style&index=0&id=2b28d0c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28d0c1",
  null
  
)

export default component.exports